import { ref, resolveComponent, createBlock, openBlock, withCtx, createVNode, createElementBlock, Fragment, renderList, resolveDynamicComponent } from "vue";
import _sfc_main$1 from "./UsersSection.vue.js";
import RolesSection from "./RolesSection.vue.js";
import _sfc_main$2 from "./OperationsSection.vue.js";
import "../../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../../constants/UserPolicy.js";
import "pinia";
import "../../../store/index.js";
import { useI18n } from "../../../plugins/i18n.js";
import "../../../plugins/banza/img.js";
import "axios";
import "vue-router";
import "maska";
import "../../../graphql/queries.js";
import "../../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../../constants/components/index.js";
/* empty css                            */
import "vuetify/components/VDialog";
import "../../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                           */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                     */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../../assets/8a32dc557a826bf0.png";
/* empty css                        */
import "../../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                    */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../../Auth/AppleAuthButton/AppleAuthButton.js";
import "../../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                                  */
import "vuetify/components/VGrid";
import "../../Base/index.js";
import "vuex";
/* empty css                           */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../../icons/mdi/index.js";
/* empty css                               */
import "vuetify/components/VBtnToggle";
import "../../../assets/6f5dc1ff0a697731.svg";
import "../../../assets/888bb8db73be3c15.svg";
/* empty css                                */
import "vuetify/components/VInfiniteScroll";
/* empty css                                     */
/* empty css                         */
import "vuetify/components/VChip";
/* empty css                             */
import "../../HtmlEditor/index.js";
import "../../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                                  */
/* empty css                           */
import "../../News/NewsModule/NewsModule.vue.js";
import "../../News/NewsModule/NewsList.vue.js";
import "../../../graphql/news.js";
/* empty css                           */
import "../../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                    */
import "vuetify/components/VWindow";
import "../../../assets/5a0af7dd23957928.png";
import "tiny-emitter/instance";
import "../../../graphql/system-settings.js";
/* empty css                                */
/* empty css                                       */
import "vuetify/components/VHover";
import "../../../constants/NewsGroup.js";
/* empty css                                        */
import { VTabsWindow, VTabsWindowItem, VTabs, VTab } from "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                      */
import "vuetify/components/VBottomSheet";
import "../../../graphql/favorites.js";
import "../../../plugins/tracker/page-tracker.js";
/* empty css                                */
import "../../../graphql/notifications.js";
/* empty css                                     */
import "../../../constants/CommunicationChannels.js";
/* empty css                               */
import "vuetify/components/VColorPicker";
/* empty css                                                   */
import "vuetify/components/VTextarea";
/* empty css                               */
import "vuetify/components/VTooltip";
/* empty css                                                */
/* empty css                             */
import "graphql-tag";
import "../../../graphql/lookups.js";
import "../../../graphql/entity.js";
/* empty css                          */
import "vuetify/components";
/* empty css                                */
/* empty css                        */
import "../../../graphql/system-events.js";
/* empty css                                           */
/* empty css                            */
/* empty css                            */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../../graphql/files.js";
/* empty css                 */
import "vue-dndrop";
/* empty css                                               */
/* empty css                                       */
import "vue-advanced-cropper";
import "../../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                           */
import "vuetify/components/VFileInput";
/* empty css                               */
import "vuetify/components/VAvatar";
/* empty css                                     */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                                 */
import "../../../graphql/public-articles.js";
/* empty css                                              */
/* empty css                                  */
import "vuetify/components/VChipGroup";
import "vuetify/components/VForm";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                     */
import "vuetify/components/VItemGroup";
/* empty css                                */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                           */
import "../../../graphql/quartz.js";
import "vue-i18n";
import "../../../graphql/integration-systems.js";
import "../../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                         */
/* empty css                                       */
import "../../../graphql/session-store.js";
import "../../../composables/useModalPage.js";
import "../../../icons/portal/index.js";
const _sfc_main = {
  __name: "UsersModule",
  props: {
    useLdap: {
      type: Boolean,
      default: false
    },
    canAddUser: {
      type: Boolean,
      default: false
    },
    canCreateRole: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const { t } = useI18n();
    const tabs = [
      {
        value: "users",
        text: t("base.labels.users"),
        icon: "mdi-account",
        component: _sfc_main$1
      },
      {
        value: "roles",
        text: t("base.labels.roles"),
        icon: "mdi-account-group",
        component: RolesSection
      },
      {
        value: "operations",
        text: t("base.labels.operations"),
        icon: "mdi-cog",
        component: _sfc_main$2
      }
    ];
    const tabRefs = ref({});
    const selectedTab = ref(null);
    const reload = () => {
      const tab = tabRefs.value[selectedTab.value];
      if (tab) {
        tab.reload();
      }
    };
    return (_ctx, _cache) => {
      const _component_b_btn = resolveComponent("b-btn");
      const _component_b_section = resolveComponent("b-section");
      return openBlock(), createBlock(_component_b_section, {
        header: _ctx.$t("base.labels.administration"),
        class: "users-module"
      }, {
        "header-actions": withCtx(() => [
          createVNode(VTabs, {
            modelValue: selectedTab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selectedTab.value = $event),
            color: "primary"
          }, {
            default: withCtx(() => [
              (openBlock(), createElementBlock(Fragment, null, renderList(tabs, (item) => {
                return createVNode(VTab, {
                  "prepend-icon": item.icon,
                  text: item.text,
                  value: item.value,
                  class: "text-none"
                }, null, 8, ["prepend-icon", "text", "value"]);
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          createVNode(_component_b_btn, {
            preset: "moduleReload",
            onClick: reload
          })
        ]),
        content: withCtx(() => [
          createVNode(VTabsWindow, {
            modelValue: selectedTab.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => selectedTab.value = $event),
            class: ""
          }, {
            default: withCtx(() => [
              (openBlock(), createElementBlock(Fragment, null, renderList(tabs, (tab) => {
                return createVNode(VTabsWindowItem, {
                  value: tab.value
                }, {
                  default: withCtx(() => [
                    (openBlock(), createBlock(resolveDynamicComponent(tab.component), {
                      class: "pa-0",
                      ref_for: true,
                      ref: (ref2) => tabRefs.value[tab.value] = ref2,
                      canAddUser: __props.canAddUser,
                      useLdap: __props.useLdap,
                      canCreateRole: __props.canCreateRole
                    }, null, 8, ["canAddUser", "useLdap", "canCreateRole"]))
                  ]),
                  _: 2
                }, 1032, ["value"]);
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["header"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
